/**
 * Auth0 Configuration
 * Configure Auth0 provider with domain and client ID from environment variables
 */

export const auth0Config :any = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  redirectUri: window.location.origin,
  logoutRedirectUri: import.meta.env.VITE_AUTH0_LOGOUT_URL || 'http://localhost:3000',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  scope: 'openid profile email offline_access',
  'ext-returnPath':'/devices',
  'ext-redirectURI': window.location.origin
}
